import React from 'react';

// Components
import WpChoice from '../choice/WpChoice';

export interface Props {
  /** ID for the input */
  id: string;
  /** Initial value for the input */
  value: string;
  /** Name for form input */
  name?: string;
  /** Additional hint text to display */
  descriptionText?: string;
  /** Radio button is selected */
  checked?: boolean;
  /** Label for the input */
  label: string;
  /** Data tag for the spec tests */
  qaTest?: string;
  /** Disable the input */
  disabled?: boolean;
  /** Automatically focus the input */
  autoFocus?: boolean;
  /** Callback when value is changed */
  onChange?(value: string): void;
  /** component used to replace label if included */
  component?: React.ReactNode;
}

const WpRadioInput: React.FC<Props> = ({
  id,
  value,
  name,
  descriptionText,
  label,
  checked,
  autoFocus,
  qaTest,
  disabled,
  onChange,
  component,
}: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(event.currentTarget.value);
  };

  const baseClassName = 'WpRadioInput';
  return (
    <WpChoice
      id={id}
      label={label}
      descriptionText={descriptionText}
      onClick={() => handleChange}
      component={component}
    >
      <div className={baseClassName}>
        <input
          id={id}
          name={name}
          value={value}
          type="radio"
          data-test={qaTest}
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
          autoFocus={autoFocus}
        />
      </div>
    </WpChoice>
  );
};

export default WpRadioInput;
